import {
	CONNECT_OUTREACH_SUCCESS,
	DISCONNECT_APP_SUCCESS,
	GET_APPLICATIONS,
	GET_APPLICATIONS_FAILURE,
	GET_APPLICATIONS_SUCCESS,
} from './types';

export interface IAppliaction {
	_id: string;
	name: string;
	status: AppStatusEnum;
}

export const defaultState = {
	data: [] as IAppliaction[],
	isLoading: false,
	isLoaded: false,
	error: null,
};

export enum AppStatusEnum {
	ACTIVE = 'active',
	PENDING = 'pending',
	OFFLINE = 'offline',
}

export type IApplicationsState = typeof defaultState;

export const applications = (
	state = defaultState,
	action: any
): IApplicationsState => {
	const { type, payload } = action;
	switch (type) {
		case GET_APPLICATIONS:
			return {
				...state,
				isLoading: true,
				error: null,
			};
		case GET_APPLICATIONS_SUCCESS:
			return {
				...state,
				data: payload,
				isLoading: false,
				isLoaded: true,
				error: null,
			};
		case GET_APPLICATIONS_FAILURE:
			return {
				...state,
				isLoading: false,
				isLoaded: true,
				error: payload,
			};
		case CONNECT_OUTREACH_SUCCESS:
			return {
				...state,
				data: state.data.map(app => {
					if (app.name === 'Outreach.io') {
						return { ...app, status: AppStatusEnum.ACTIVE };
					}
					return app;
				}),
			};
		case DISCONNECT_APP_SUCCESS:
			return {
				...state,
				data: state.data.map(app => {
					if (app._id === payload) {
						return { ...app, status: AppStatusEnum.OFFLINE };
					}
					return app;
				}),
			};
		default:
			return state;
	}
};
